import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    CardMedia,
    Divider,
    Radio,
    Skeleton,
    SxProps,
    Typography,
    useTheme,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { getInvestorTokenCompany, getJointAccountList, getRoleBasedPermissions, showError } from '../../redux-store/actions/auth';
import { getInvestorDetails } from '../../redux-store/actions/investorProfile';
import { useHistory } from 'react-router';
import { GetInvestorTokenCompanyResponseBody, GetRoleBasedPermissionsResponseBody, VerifyLoginOtpResponseBody } from '../../redux-store/types/api-types';
import { storeApplicationId, storeInterfaceCode, storeInvestorClientId, storeIwappId } from '../../redux-store/actions/id';
import { VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { LoadingButton } from '@mui/lab';
import { SET_APPLICATION_ID } from '../../redux-store/types/onBoarding';
import { ENABLE_DIY_INVESTOR_ONBOARDING, MPOWER_ACCOUNT_TYPE_MASTER } from '../../utils/constant';
import { setInvestorRmId } from '../../redux-store/actions/sessionData';
import { LoginLayout } from '../commonComponents';

// type Props = {}

type AccountData = {
    accountType: string
    primaryHolder: string
    jointHolder1?: string
    jointHolder2?: string
    id: number
    clientCode: string
    rmId: string
    clientInterfaceCode: string | null;
    status?: string
    applicationNumber?: string;
    account?: string;
    onboardingType?: string;
    minorName?: string;
    isFamilyHead?: string;
}

type AccountList = Array<AccountData>

type GetJointAccountList = {
    isSuccess: boolean
    message: string
    data: {
        accountList: AccountList
    }
}

type GetData = {
    token: string;
    id: number;
    role: string;
    adminSupport: boolean;
    jointHolderData: AccountList
}
function JointHolderType() {
    const { palette, typography } = useTheme();
    const dispatch = useDispatch()
    const history = useHistory()
    const [accountList, setAccountList] = useState<AccountList>([]);
    const [selectedAccount, setSelectedAccount] = useState<number>();
    const [jointHolderLoading, setJointLoaderHolding] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const state = history.location.state as GetData

    useEffect(() => {
        if (state?.token) initialFetch()
    }, [state])


    const initialFetch = async () => {
        try {
            setJointLoaderHolding(true);
            setAccountList(ENABLE_DIY_INVESTOR_ONBOARDING ? state.jointHolderData : state.jointHolderData?.filter(item => item.status?.toLowerCase() === 'completed'))
            setSelectedAccount(state.jointHolderData[0]?.id)
        } catch (e) {
            console.log("ERROR IN JOINT LOADING", e);
        } finally {
            setJointLoaderHolding(false)
        }

    }

    const onAccountSelect = (id: number) => {
        setSelectedAccount(id)
    }

    const handleSubmit = async () => {
        const filterData = accountList?.filter(item => item?.id === selectedAccount)
        dispatch(storeInvestorClientId({ investorClientId: filterData[0]?.clientCode }));
        dispatch(storeInterfaceCode(filterData[0]?.clientInterfaceCode));
        dispatch(storeIwappId({ iwappRmId: filterData[0]?.rmId }));
        dispatch(setInvestorRmId(filterData[0]?.rmId ?? ''))

        const showDiyInvestorOnboarding = filterData?.[0]?.status?.toLowerCase() === "draft"
        const showDiyInvOnboardingPrev = !['draft', 'completed'].includes(filterData?.[0]?.status?.toLowerCase() ?? '');

        try {
            setIsLoading(true);
            // const tokenWithCompanyRes = await fetch(`api/users/users/generate-investor-token-with-company`, {
            //     method: 'POST',
            //     headers: {
            //         Accept: "application/json",
            //         "Content-Type": "application/json",
            //         Expires: '0',
            //         Authorization: "Bearer " + (state?.token || '') as string
            //     },
            //     body: JSON.stringify({ clientCode: filterData[0]?.clientCode, applicationId: filterData[0]?.id })
            // }).then((res) => res.json())

            const tokenWithCompanyRes = await dispatch(getInvestorTokenCompany({
                clientCode: filterData[0]?.clientCode,
                applicationId: filterData[0]?.id,
                temporaryToken: state?.token
            }) as unknown as Promise<GetInvestorTokenCompanyResponseBody>)


            if (tokenWithCompanyRes.isSuccess) {
                const permissionResponse = await dispatch(getRoleBasedPermissions({
                    temporaryToken: tokenWithCompanyRes?.token ?? ""
                }) as unknown as Promise<GetRoleBasedPermissionsResponseBody>)

                dispatch(storeApplicationId({ applicationId: filterData[0]?.id }))
                dispatch({
                    type: VERIFY_LOGIN_OTP_SUCCESS,
                    body: {
                        ...tokenWithCompanyRes,
                        diyInvestorOnboardingEdit: showDiyInvestorOnboarding,
                        diyInvOnboardingPrev: showDiyInvOnboardingPrev,
                        permissions: permissionResponse?.permissions[`${tokenWithCompanyRes?.role ?? ""}`.toLowerCase()] ?? []
                    }
                })

                if (showDiyInvestorOnboarding) {
                    dispatch(showError("Please complete your onboarding journey"))
                    history.replace('/investor-onboarding-application/personal-details', { id: filterData?.[0]?.id });
                }
            }
        }
        catch (e) {
            console.log("ERROR IN JOINT LOADING", e);

        } finally {
            setIsLoading(false);
        }
        // console.log(filterData)
    }

    return (
        // <JointHolderLayout>
        <LoginLayout LoginText="" renderChildUI>
            {
                jointHolderLoading ?
                    <Box
                        sx={{
                            background: palette.common.white,
                            borderRadius: '24px',
                            padding: '24px',
                            width: { xl: '30%', lg: '40%', md: '50%', sm: '60%', xs: '80%' },
                        }}>
                        <Box>
                            <Skeleton animation="wave" />
                            <Skeleton animation="wave" />
                        </Box>
                        <Box
                            sx={{
                                mt: '30px',
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: '16px',
                                height: { lg: 'auto', md: 'auto', sm: 'auto', xs: '55vh' },
                                overflowY: { lg: 'auto', md: 'auto', sm: 'auto', xs: 'auto' },
                            }}>
                            <Box
                                sx={{
                                    width: '100%',
                                    padding: '24px',
                                    borderRadius: '15px',
                                    border: `1px solid ${palette.textDark.secondary}`,
                                }}>
                                <Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}>
                                        <Skeleton animation="wave" variant='circular' width={'5%'} height={'15px'} />
                                        <Skeleton animation="wave" sx={{ ml: '16px', width: '50%' }} />
                                        <Skeleton animation="wave" sx={{ ml: '8px', width: '50%' }} />
                                    </Box>
                                    <Skeleton animation="wave" sx={{ my: '24px', height: '5px' }} />
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        rowGap: '24px',
                                        columnGap: '50px',
                                        // flexWrap: 'wrap',
                                        width: '100%'
                                    }}>

                                        <Box sx={{ width: '33%' }}>
                                            <Skeleton animation="wave" width={'50%'} />
                                            <Skeleton animation="wave" width={'100%'} />
                                        </Box>

                                        <Box sx={{ width: '33%' }}>
                                            <Skeleton animation="wave" width={'50%'} />
                                            <Skeleton animation="wave" width={'100%'} />
                                        </Box>

                                        <Box sx={{ width: '33%' }}>
                                            <Skeleton animation="wave" width={'50%'} />
                                            <Skeleton animation="wave" width={'100%'} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box >
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: { xl: 'flex-end', md: 'flex-end', sm: 'center', xs: 'center' } }}>
                            <Skeleton animation="wave" variant='rectangular' width={'30%'} sx={{ mt: '30px', textAlign: 'right', height: '40px', borderRadius: '10px' }} />
                        </Box>

                    </Box> :
                    <Box
                        sx={{
                            background: palette.common.white,
                            borderRadius: '24px',
                            padding: '24px',
                            maxWidth: 'fit-content',
                            width: { xl: '30%', lg: '40%', md: '50%', sm: '60%', xs: '80%' },
                            // width: '80%',
                        }}>
                        <Box>
                            <Typography variant="h2" color={palette.primary[500]}>
                                Account type
                            </Typography>
                            <Typography id="account-selection-group-label" variant="body_400" color={palette.text.secondary}>
                                Choose which account to login
                            </Typography>
                        </Box>
                        <Box
                            role="radiogroup"
                            aria-labelledby="account-selection-group-label"
                            sx={{
                                mt: '30px',
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: '16px',
                                height: { lg: 'auto', md: 'auto', sm: 'auto', xs: '55vh' },
                                maxHeight: { lg: '55vh', md: '55vh', sm: '55vh', xs: '55vh' },
                                overflowY: { lg: 'auto', md: 'auto', sm: 'auto', xs: 'scroll' },
                            }}>
                            {accountList?.map((item, index) => (
                                <Cart
                                    key={index}
                                    data={item}
                                    onAccountSelect={onAccountSelect}
                                    selectedAccount={selectedAccount}
                                    index={index}
                                    total={accountList?.length ?? 0}
                                />
                            ))}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'center', xs: 'center' } }}>
                            <LoadingButton
                                onClick={handleSubmit}
                                sx={{
                                    ...typography.body_500,
                                    mt: '30px',
                                    height: '53px',
                                }}
                                variant='contained'
                                loading={isLoading}
                            >
                                Continue
                            </LoadingButton>
                        </Box>
                    </Box>
            }
        </LoginLayout>
        // </JointHolderLayout>
    );
}

export default JointHolderType;

const Cart = ({ data, onAccountSelect, selectedAccount, index, total }: { data: AccountData, onAccountSelect: (id: number) => void, selectedAccount?: number, index: number, total: number }) => {
    const { palette } = useTheme();
    const accountTypeLabel = `${data?.accountType}${data?.onboardingType?.toLowerCase() === 'minor' ? '(Minor)' : ''}`;
    const radioLabel = `${data.primaryHolder} – ${accountTypeLabel}`;

    return (
        <Box
            onClick={() => onAccountSelect(data.id)}
            sx={{
                maxWidth: '592px',
                width: '100%',
                background: data.id === selectedAccount ? palette.primary[500] + '14' : palette.customColors.infoCard,
                padding: '24px',
                borderRadius: '15px',
                cursor: 'pointer',
                border: `1px solid ${data.id === selectedAccount ? palette.primary[500] : palette.grey[300]}`,
            }}>
            <Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}>
                    <Radio
                        name="account-selection"
                        value={data.id}
                        size="small"
                        sx={{
                            '&.MuiRadio-sizeSmall': {
                                padding: '0px',
                            },
                        }}
                        checked={data.id === selectedAccount}
                        onChange={() => null}
                        inputProps={{
                            'aria-label': radioLabel,
                            'aria-posinset': index + 1,
                            'aria-setsize': total,
                        }}
                    />
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>

                            <HeaderText
                                style={{ ml: '16px' }}
                                text='Investor Type:' />
                            <ValueText
                                style={{ ml: '8px' }}
                                text={`${data?.accountType}${data?.onboardingType?.toLowerCase() === 'minor' ? '(Minor)' : ''}`}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>

                            <HeaderText
                                style={{ ml: '16px' }}
                                text='Account Type:' />
                            <ValueText
                                style={{ ml: '8px' }}
                                text={MPOWER_ACCOUNT_TYPE_MASTER[data?.account ?? ""]} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>

                            <HeaderText
                                style={{ ml: '16px' }}
                                text='Client Code:' />
                            <ValueText
                                style={{ ml: '8px' }}
                                text={data?.clientCode} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>

                            <HeaderText
                                style={{ ml: '16px' }}
                                text='Status:' />
                            <ValueText
                                style={{ ml: '8px', textTransform: 'capitalize' }}
                                text={data?.status ?? "-"} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>

                            <HeaderText
                                style={{ ml: '16px' }}
                                text='Application Number:' />
                            <ValueText
                                style={{ ml: '8px' }}
                                text={data?.applicationNumber ?? "-"} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                            <HeaderText
                                style={{ ml: '16px' }}
                                text='Head Of Family:' />
                            <ValueText
                                style={{ ml: '8px' }}
                                text={`${data?.isFamilyHead ?? ""}`.toLowerCase() === "y" ? "Yes" : "No"} />
                        </Box>

                    </Box>
                </Box>
                <Divider sx={{ my: '24px' }} />
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    rowGap: '24px',
                    columnGap: '50px',
                    flexWrap: 'wrap',
                }}>
                    {data?.primaryHolder && (
                        <Box >
                            <HeaderText
                                text={data?.onboardingType?.toLowerCase() === 'minor' ? 'Guardian Name' : 'Primary Holder'}
                            />
                            <ValueText
                                text={data.primaryHolder} />
                        </Box>
                    )}
                    {data?.onboardingType?.toLowerCase() === 'minor' ?
                        (
                            <Box >
                                <HeaderText
                                    text='Minor Name' />
                                <ValueText
                                    text={data?.minorName || '-'} />
                            </Box>
                        )
                        :
                        data?.jointHolder1 && (
                            <Box >
                                <HeaderText
                                    text='Joint Holder 1' />
                                <ValueText
                                    text={data?.jointHolder1 || ''} />
                            </Box>
                        )
                    }
                    {data?.jointHolder2 && (
                        <Box >
                            <HeaderText
                                text='Joint Holder 2' />
                            <ValueText
                                text={data?.jointHolder2 || ''} />
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

type HearderProps = {
    text: string
    style?: SxProps
}

const HeaderText = ({ text, style = {} }: HearderProps) => {
    const { palette } = useTheme();
    return (
        <Typography
            sx={style}
            variant="body_500"
            fontSize={{ lg: '16px', md: '14px', sm: '12px', xs: '12px' }}
            color={palette.customColors.infoCardTitle}>
            {text}
        </Typography>
    )
}
type ValueProps = {
    text: string
    style?: SxProps
}

const ValueText = ({ text, style = {} }: ValueProps) => {
    const { palette } = useTheme();
    return (
        <Typography
            sx={style}
            variant="h3"
            fontSize={{ lg: '16px', md: '14px', sm: '12px', xs: '12px' }}
            color={palette.text.primary}>
            {text}
        </Typography>
    )
}

type Props = {
    children: string | JSX.Element | JSX.Element[] | React.ReactNode;
};
// const JointHolderLayout = ({ children }: Props) => {
//     const { palette } = useTheme();
//     return (
//         <Box
//             sx={{
//                 backgroundImage: `url(https://s3-alpha-sig.figma.com/img/3d5c/a88b/b8c065cdfb2f5bafd31f9a8bcb9c1396?Expires=1718582400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=hEbGp7im3Lyfzl-fofqIwYcUXeLiYhRprVS8cLnGAyMpqZP0jIaKuyVbw2ldVpgEdz85fV6493A4dmifn74efyqK6A-61i6mo5YyfIk9H5L6sbeTjrOZeFLumy1Jn5a9TgDuqnlL4BFTaDBshtZinzAIl-3ORLa6ROEP4p~GGEQ~f80v5BDYBAJm4jVwH~6QzaTF-YCX-2EMWWxb21aVmqhV5RklgynfI-mMg1xEEEufze0MzceKWhE6jemYBDvZDNNPlg~XFwFbr2RxS5vRXXfTsJUPBLIKMRDbNzJiLRLLHFyLnsQY26TiFO8w~J8T8NUL7MuZuaGjWe0FjNlWaA__)`,
//                 backgroundRepeat: 'no-repeat',
//                 backgroundAttachment: 'fixed',
//                 backgroundPosition: '100% 77%',
//                 width: '100%',
//                 // minHeight: '100vh',
//                 backgroundSize: { lg: '140%', md: '140%', sm: 'cover', xs: 'cover' },
//                 overflowY: 'auto',
//                 // backgroundColor: palette.customColors.loginBackgrounblue + '4D',
//                 boxShadow: 'inset 0 0 0 1000px ' + palette.customColors.loginBackgrounblue + '4D',
//             }}>
//             <Box
//                 sx={{
//                     position: 'relative',
//                     zIndex: 2,
//                     display: 'flex',
//                     height: '100vh',
//                     flexDirection: 'column',
//                 }}>
//                 <Box
//                     sx={{
//                         width: '100%',
//                         background: palette.common.black + '80',
//                     }}>
//                     <CardMedia
//                         component="img"
//                         // src="/images/kfintechHeaderImg.svg"
//                         // src="/images/mPowerWealth_Logo.svg"
//                         src="/images/nexedge_logo_dark.png"
//                         // alt="kFintech Logo"
//                         alt="Logo"
//                         sx={{
//                             // width: 'unset',
//                             // width: "15rem",
//                             // margin: "30px 0px 20px 15px"
//                             width: '12rem',
//                             margin: '30px 0px 20px 30px'
//                         }}
//                     />
//                 </Box>
//                 <Box
//                     sx={{
//                         // display: 'grid',
//                         // placeItems: 'center',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         margin: { lg: 'auto 0', md: 'auto 0', sm: 'auto 0', xs: '20px' },
//                     }}>
//                     {children}
//                 </Box>
//             </Box>
//         </Box>
//     );
// };
